import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import TranslationProvider from '../../providers/TranslationProvider';
import SafetyMeasureCategoryIcon from '../SafetyMeasureCategoryIcon';
import Icon from '../Icon';
import Link from '../Link';

import Check from '../../svg/icons/checkmark.svg';

import './SafetyMeasureList.scss';

const SafetyMeasureList = ({
  categories,
  className,
  referrer,
  smallFont,
  url,
  venueName,
}) => {
  const activeCategories = categories?.filter((category) => category.items.some((item) => item.active));

  if (!activeCategories) {
    return null;
  }

  return (
    <div className={cx('SafetyMeasureList', className, { 'SafetyMeasureList--small': smallFont })}>
      <TranslationProvider translationKey="safety_measures">
        <h2 className={cx('SafetyMeasureList__title', {
          'SafetyMeasureList__title--widget': referrer === 'widget',
        })}
        >
          Safety Measures
        </h2>
      </TranslationProvider>
      <TranslationProvider translationKey="health_safety_description">
        <div className={cx('SafetyMeasureList__description', {
          'SafetyMeasureList__description--widget': referrer === 'widget',
        })}
        >
          This restaurant has committed to taking certain safety measures to
          provide a safe, comfortable dining experience.
        </div>
      </TranslationProvider>
      <div className="SafetyMeasureList__list-container">
        {activeCategories.map((category, index) => (
          <div
            className={cx(
              'SafetyMeasureList__list-item-container',
              {
                'SafetyMeasureList__list-item-container--last': index === activeCategories.length - 1 && activeCategories.length % 2 === 1,
              }
            )}
            key={category.id}
          >
            <SafetyMeasureCategoryIcon category={category} big />
            <ul>
              {category.items.map((item) => (
                <li className="SafetyMeasureList__list-item" key={item.id}>
                  <span className="icon">
                    <Icon component={Check} name={item.value} />
                  </span>
                  <div className={cx('name', { 'name--small': smallFont })}>{item.value}</div>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      {url && (
        <div className="SafetyMeasureList__url">
          <TranslationProvider translationKey="venue_safety_description" translationValues={{ venueName }}>
            <span>{`${venueName} has provided resources to learn even more about what they're doing to ensure a safe and comfortable dining experience.`}</span>
          </TranslationProvider>
          {' '}
          <TranslationProvider translationKey="take_a_look">
            <Link
              href={url}
              className="venue-link"
              target="_blank"
            >
              Take a look
            </Link>
          </TranslationProvider>
        </div>
      )}
    </div>
  );
};

SafetyMeasureList.propTypes = {
  categories: PropTypes.arrayOf(PropTypes.shape).isRequired,
  className: PropTypes.string,
  referrer: PropTypes.oneOf(['venue page', 'event page', 'widget']), // where was this rendered (used for tracking)
  smallFont: PropTypes.bool,
  url: PropTypes.string,
  venueName: PropTypes.string.isRequired,
};

SafetyMeasureList.defaultProps = {
  className: '',
  referrer: 'venue page',
  smallFont: false,
  url: undefined,
};

SafetyMeasureList.displayName = 'SafetyMeasureList';
export default SafetyMeasureList;
